export default __webpack_public_path__ + "static/media/00.4e48e60f.jpg";